// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { collection, getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions, httpsCallable } from "firebase/functions";
import { initializeAppCheck, ReCaptchaV3Provider,  } from "firebase/app-check";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfigDev = {
  apiKey: "AIzaSyBJN2OOKbKhetKfSZx52FpI3cUAdMwti7Q",
  authDomain: "quicktales-f8a59.firebaseapp.com",
  projectId: "quicktales-f8a59",
  storageBucket: "quicktales-f8a59.appspot.com",
  messagingSenderId: "866616932813",
  appId: "1:866616932813:web:9f7a977d1adfc30cea6c84",
  measurementId: "G-LD47YFB289",
};

const firebaseConfigStaging = {
  apiKey: "AIzaSyBoqmoj5KbkexpPFc3Z5fQwSlQ6_9TcA30",
  authDomain: "quicktales-staging.firebaseapp.com",
  projectId: "quicktales-staging",
  storageBucket: "quicktales-staging.appspot.com",
  messagingSenderId: "833642917450",
  appId: "1:833642917450:web:b08647231790d3266840b3",
  measurementId: "G-5XTWCN4XPH",
};

const firebaseConfigProduction = {
  apiKey: "AIzaSyDvv3p53pMKFieYVR9znS1_yjz1Q2rAoTA",
  authDomain: "quicktales-prod.firebaseapp.com",
  projectId: "quicktales-prod",
  storageBucket: "quicktales-prod.appspot.com",
  messagingSenderId: "48146980674",
  appId: "1:48146980674:web:9afde4dae55670c5e832db",
  measurementId: "G-PJYVPKNV43",
};

console.log(`Current Environment: ${process.env.REACT_APP_PROJECT_ENVIROMENT}`);

const firebaseConfig =
  process.env.REACT_APP_PROJECT_ENVIROMENT == "development"
    ? firebaseConfigDev
    : process.env.REACT_APP_PROJECT_ENVIROMENT == "production"
    ? firebaseConfigProduction
    : firebaseConfigStaging;

const recaptchaSiteKey =
  process.env.REACT_APP_PROJECT_ENVIROMENT === "development"
    ? "6LdSRl4qAAAAADBU6KyQdSLAw-3QOq0hK6LnEwPB"
    : process.env.REACT_APP_PROJECT_ENVIROMENT === "production"
    ? "6LdBRl4qAAAAACNeT6ZoUmIsEvr3pNehYSj5FyNb"
    : "6LfCRV4qAAAAAKHxW3_3zfMwFWgFkAXRVCIWpeu7";
// const recaptchaSiteKey =
//   process.env.REACT_APP_PROJECT_ENVIROMENT === "development"
//     ? process.env.REACT_APP_RECAPTCHA_SITE_KEY_DEV
//     : process.env.REACT_APP_PROJECT_ENVIROMENT === "production"
//     ? process.env.REACT_APP_RECAPTCHA_SITE_KEY_PRODUCTION
//     : process.env.REACT_APP_RECAPTCHA_SITE_KEY_STAGING;

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider(recaptchaSiteKey), // Use the dynamic key

  isTokenAutoRefreshEnabled: true, // Optional: auto-refresh tokens
});

// appCheck.getToken(true).then((tokenResult) => {
//   console.log('AppCheck Token: ', tokenResult.token);
// }).catch((error) => {
//   console.error('Error fetching AppCheck token: ', error);
// });

// const appCheck = initializeAppCheck(app, {
//   provider: new ReCaptchaV3Provider("6Le5Ll4qAAAAACsbL-V-usAwJtStDnWxUsTSTiFW"),

//   // Optional argument. If true, the SDK automatically refreshes App Check
//   // tokens as needed.
//   isTokenAutoRefreshEnabled: true,
// });
// Initialize Firebase Authentication and get a reference to the service
// export const auth = getAuth(appCheck);
// export const db = getFirestore(appCheck);
// export const storage = getStorage(appCheck);
// export const functions = getFunctions(appCheck);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-central1');

export { sendPasswordResetEmail };

// Cloud Functions wrappers
export const importQuicktaleBatch = httpsCallable(functions, "importQuicktaleBatch");
export const promoteBatchQuicktale = httpsCallable(functions, "promoteBatchQuicktale");

//firebase/firestore collections refs
export const QuickTalesRef = collection(db, "quicktales");
export const NotificationRef = collection(db, "notifications");
export const NotificationsAdminRef = collection(db, "notificationsAdmin");
export const HistoryRef = collection(db, "history");
export const DashboardAnalyticsRef = collection(db, "dashboardAnalytics");
export const ReactionsRef = collection(db, "quicktaleReaction");
export const AlbumsRef = collection(db, "albums");
export const AlbumShareRef = collection(db, "albumShare");
export const QuickTaleShareRef = collection(db, "quicktaleShare");
export const AdminsTableRef = collection(db, "admins");
export const AdminsRef = collection(db, "admins");
export const AdminInvitesRef = collection(db, "adminInvites");
export const OrgProRef = collection(db, "organizations");
export const ContributorsRef = collection(db, "users");
export const ContributorsInvitesRef = collection(db, "contributorsInvites");
export const AreaManagementRef = collection(db, "area");
export const GroupRef = collection(db, "group");
export const QTLikesRef = collection(db, "quicktaleLike");
export const AlbumsLikesRef = collection(db, "albumLike");
export const ContentReportsRef = collection(db, "reportTicket");
export const clarifaiSettingsRef = collection(db, "clarifaiSettings");
export const CustomNarratorsRef = collection(db, "customNarrators");
export const OrgEmailTemplatesRef = collection(db, "orgEmailTemplates");
// Standard (General Admin) email templates. Same shape as orgEmailTemplates
// minus `organization`. Orgs copy these into orgEmailTemplates.
export const GenEmailTemplatesRef = collection(db, "genEmailTemplates");
// QuickCollect guest-page templates. See docs/QUICKCOLLECT_IMPLEMENTATION.md
export const OrgQCTemplatesRef = collection(db, "orgQCTemplates");
export const BatchesRef = collection(db, "batches");
export const BatchQuicktalesRef = collection(db, "batchQuicktales");
export const UserActivityRef = collection(db, "user_activity");
// Marketing / sales site CMS content. See docs/SALES_PAGES_CMS.md
// The base collections are the working "draft" copies the admin edits.
export const SalesPagesContentRef = collection(db, "salesPagesContent");
// Marketing / sales site pages (one doc per page). See docs/SALES_PAGES_CMS.md
export const SalesPagesRef = collection(db, "salesPages");
// Published copies (what the live site reads). Same document IDs as the draft
// collections; Publish upserts a draft doc into its published twin.
export const SalesPagesContentPublishedRef = collection(
  db,
  "salesPagesContentPublished"
);
export const SalesPagesPublishedRef = collection(db, "salesPagesPublished");
// Contact form submissions (written by the submitContactForm cloud function).
export const ContactSubmissionsRef = collection(db, "contactSubmissions");

//firebase cloud functions
export const deleteUserAuth = httpsCallable(functions, "deleteUser");
export const updateUserStatus = httpsCallable(functions, "updateUserStatus");
export const updateAdminStatus = httpsCallable(functions, "updateAdminStatus");
export const sendEmail = httpsCallable(functions, "sendEmail");
export const sendEmailOnCall = httpsCallable(functions, "sendEmailOnCall");
export const checkUserAuth = httpsCallable(functions, "checkUserAuth");
export const sendPushNotification = httpsCallable(
  functions,
  "sendPushNotification"
);
export const disableUserFunction = httpsCallable(functions, "disableUser");
export const enableUserFunction = httpsCallable(functions, "enableUser");
export const updateUserEmail = httpsCallable(functions, "updateUserEmail");
export const changeAdminPassword = httpsCallable(
  functions,
  "changeAdminPassword"
);
export const changeSelfPassword = httpsCallable(functions, "changePassword");
export const fetchUserAuthDetails = httpsCallable(functions, "fetchUserAuthDetails");
export const insertQTAddSearchDocumentData = httpsCallable(functions, "insertQTAddSearchDocumentData");
// Google Cloud Vision Product Search migration (replaces Clarifai indexing)
export const indexSingleQuickTaleToVision = httpsCallable(functions, "indexSingleQuickTaleToVision");
export const indexQuickTalesBatchToVision = httpsCallable(functions, "indexQuickTalesBatchToVision");

export const getNarratorsAnalytics = httpsCallable(functions, "getNarratorsAnalytics");
export const getCreatorsAnalytics = httpsCallable(functions, "getCreatorsAnalytics");

// In-house search index backfill (AddSearch replacement). See
// docs/ADDSEARCH_REPLACEMENT_PLAN.md (Phase 1.6).
export const rebuildSearchIndex = httpsCallable(functions, "rebuildSearchIndex");
// In-house search endpoint (AddSearch replacement). See
// docs/ADDSEARCH_REPLACEMENT_PLAN.md (Phase 2).
export const searchQuickTales = httpsCallable(functions, "searchQuickTales");
// In-house feed ranker preview (Feed Lab). See
// docs/ADDSEARCH_REPLACEMENT_PLAN.md (Phase 3).
export const previewFeedRanking = httpsCallable(functions, "previewFeedRanking");
// Listen-count backfill from userActivity play_duration events. See
// docs/ADDSEARCH_REPLACEMENT_PLAN.md (Phase 4).
export const backfillListenCounts = httpsCallable(functions, "backfillListenCounts");
